import * as actions from '../utils/Constants';
import Routes from '../utils/Routes';

import { apiGet, apiDeleteWithBodyAndThen, apiPost, apiPostAndThen, apiRequest, Methods } from '../utils/Api';
const api = `${process.env.REACT_APP_API_HOST}api/person/`;

const getPersonApi = (id) => apiGet(api + id);

const getPersonDocumentsByTypeApi = (personId, type) => apiGet(`${process.env.REACT_APP_API_HOST}api/person/${personId}/documents/${type}`);


export const getPerson = (id) => ({
    type: actions.GET_PERSON,
    payload: getPersonApi(id)
});

export const searchPersons = (searchTerm) => ({
    type: actions.SEARCH_PERSONS,
    payload: searchTerm ? apiPost(api + 'search', { searchTerm }) : []
});

export const clearSearchedPersons = () => {
    return {
        type: actions.CLEAR_SEARCHED_PERSONS
    }
};

export const clearEditContactDetails = () => {
    return {
        type: actions.CLEAR_EDIT_CONTACT_DETAILS
    }
};

export const updatePerson = (person) => ({
    type: actions.UPDATE_PERSON,
    payload: person
});

export const updateRateField = (field, value) => ({
    type: actions.UPDATE_RATE_FIELD,
    field,
    payload: value
});

export const savePerson = (person) => ({
    type: actions.SAVE_PERSON,
    payload: apiPost(api, person)
});

export const setFromAddButton = (isFromAddButton = {}) => ({
    type: actions.FROM_ADD_BUTTON,
    payload: isFromAddButton,
});


export const getPersonDocuments = (personId) => {
    return dispatch => dispatch({
        type: actions.GET_PERSON_DOCUMENTS,
        payload: apiRequest(`${process.env.REACT_APP_API_HOST}api/person/${personId}/documents`, Methods.get, null, dispatch)
    });
};

export const getEditContact = (personId) => {
    return dispatch => dispatch({
        type: actions.GET_EDIT_CONTACT_DETAILS,
        payload: apiRequest(
            `${process.env.REACT_APP_API_HOST}api/person/getEditContactDetails?personId=${personId}`,
            Methods.get,
            null, 
            dispatch
        )
    });
};


export const getPersonDocumentsByType = (personId, type) => ({
    type: actions.GET_PERSON_DOCUMENTS,
    payload: getPersonDocumentsByTypeApi(personId, type)
});

export const addPersonDocument = (personId, type, files) => {
    const data = new FormData();
    files.forEach(file => data.append('files', file, file.fileName));

    return {
        type: actions.ADD_PERSON_DOCUMENT,
        payload: fetch(`${process.env.REACT_APP_API_HOST}api/person/${personId}/document/${type}`, {
            method: 'POST',
            credentials: 'include',
            body: data
        }).then(res => {
            return res.json();
        })
    }
}

export const deletePersonDocuments = (personId, documentIds) => {
    return dispatch => dispatch({
        type: actions.DELETE_PERSON_DOCUMENTS,
        payload: apiRequest(Routes.personDocuments, Methods.delete, documentIds, dispatch).then(() =>
            apiRequest(`${Routes.person}${personId}/documents`, Methods.get, null, dispatch))
    });
};

export const updatePersonDocument = (personId, personDocumentId, documentTypeId) => {
    return dispatch => {
        apiRequest(`${process.env.REACT_APP_API_HOST}api/person/document/${personDocumentId}`, Methods.put, documentTypeId, dispatch).then(() => {
            dispatch(getPersonDocuments(personId));
        })
    };
};

const getPersonJournalApi = (personId) => apiGet(`${process.env.REACT_APP_API_HOST}api/person/${personId}/journal`)

export const savePersonJournalEntry = (personId, journalEntry) => ({
    type: actions.ADD_UPDATE_PERSON_JOUNALENTRY,
    payload: apiPostAndThen(`${process.env.REACT_APP_API_HOST}api/person/journal`, journalEntry, () => getPersonJournalApi(personId))
});

export const getPersonJournal = (personId) => ({
    type: actions.GET_PERSON_JOURNAL,
    payload: getPersonJournalApi(personId)
});

export const clearPerson = () => ({
    type: actions.CLEAR_PERSON,
})

export const deletePersonJournalEntries = (personId, ids) => ({
    type: actions.DELETE_PERSON_JOUNALENTRIES,
    payload: apiDeleteWithBodyAndThen(`${process.env.REACT_APP_API_HOST}api/person/journal`, ids, () => getPersonJournalApi(personId))
});

const getPersonPhonesApi = (personId) => apiGet(`${process.env.REACT_APP_API_HOST}api/person/${personId}/phones`)

export const getPersonPhones = (personId) => ({
    type: actions.GET_PERSON_PHONES,
    payload: getPersonPhonesApi(personId)
});

export const getPersonTrainings = (personId) => {
    return dispatch => dispatch({
        type: actions.GET_PERSON_TRAININGS,
        payload: apiRequest(`${process.env.REACT_APP_API_HOST}api/person/${personId}/trainings`, Methods.get, null, dispatch)
    });
};

export const savePersonPhone = (personPhone) => ({
    type: actions.SAVE_PERSON_PHONES,
    payload: apiPostAndThen(`${process.env.REACT_APP_API_HOST}api/person/phones`, personPhone, () => getPersonPhonesApi(personPhone.personId))
});

export const deletePersonPhones = (personId, ids) => ({
    type: actions.DELETE_PERSON_PHONES,
    payload: apiDeleteWithBodyAndThen(`${process.env.REACT_APP_API_HOST}api/person/phones`, ids, () => getPersonPhonesApi(personId))
});

export const savePersonEmail = (personEmails) => {
    return dispatch => dispatch({
        type: actions.SAVE_PERSON_EMAILS,
        payload: apiRequest(`${process.env.REACT_APP_API_HOST}api/person/emails`, Methods.post, personEmails, dispatch)
    });
};

export const deletePersonEmails = (personId, ids) => {
    return dispatch => dispatch({
        type: actions.SAVE_PERSON_EMAILS,
        payload: apiRequest(`${process.env.REACT_APP_API_HOST}api/person/${personId}/emails`, Methods.delete, ids, dispatch)
    });
};

const getPersonAddressesApi = (personId) => apiGet(`${process.env.REACT_APP_API_HOST}api/person/${personId}/addresses`)

export const getPersonAddresses = (personId) => ({
    type: actions.GET_PERSON_ADDRESSES,
    payload: getPersonAddressesApi(personId)
});

const getPersonEmailsApi = (personId) => apiGet(`${process.env.REACT_APP_API_HOST}api/person/${personId}/emails`)

export const getPersonEmails = (personId) => ({
    type: actions.GET_PERSON_EMAILS,
    payload: getPersonEmailsApi(personId)
});

export const savePersonAddress = (personAddress) => ({
    type: actions.SAVE_PERSON_ADDRESS,
    payload: apiPostAndThen(`${process.env.REACT_APP_API_HOST}api/person/addresses`, personAddress, () => getPersonAddressesApi(personAddress.personId))
});

export const deletePersonAddresses = (personId, ids) => ({
    type: actions.DELETE_PERSON_ADDRESSES,
    payload: apiDeleteWithBodyAndThen(`${process.env.REACT_APP_API_HOST}api/person/addresses`, ids, () => getPersonAddressesApi(personId))
});


export const addUserClaim = (claim) => {
    return {
        type: actions.ADD_USER_CLAIM,
        payload: claim
    }
}

export const removeUserClaim = (claim) => {
    return {
        type: actions.REMOVE_USER_CLAIM,
        payload: claim
    }
}

export const updateUserRole = (roleId) => {
    return {
        type: actions.UPDATE_USER_ROLE,
        payload: roleId
    }
}


export const togglePasswordChangeModal = () => {
    return {
        type: actions.TOGGLE_PASSWORD_CHANGE_MODAL
    }
}

export const updateUserPassword = (userId, password) => ({
    type: actions.UPDATE_USER_PASSWORD,
    payload: apiPost(`${process.env.REACT_APP_API_HOST}api/user/${userId}/password`, password)
});


export const addPersonDiscipline = (disciplineId) => ({
    type: actions.ADD_PERSON_DISCIPLINE,
    payload: disciplineId
})

export const removePersonDiscipline = (disciplineId) => ({
    type: actions.REMOVE_PERSON_DISCIPLINE,
    payload: disciplineId
})

export const addPersonCourtType = (courtTypeId) => ({
    type: actions.ADD_PERSON_COURTTYPE,
    payload: courtTypeId
})

export const removePersonCourtType = (courtTypeId) => ({
    type: actions.REMOVE_PERSON_COURTTYPE,
    payload: courtTypeId
})

export const addPersonCommitteeAssignment = (committeeAssignmentId) => ({
    type: actions.ADD_PERSON_COMMITTEEASSIGNMENT,
    payload: committeeAssignmentId
})

export const removePersonCommitteeAssignment = (committeeAssignmentId) => ({
    type: actions.REMOVE_PERSON_COMMITTEEASSIGNMENT,
    payload: committeeAssignmentId
})

export const updatePersonType = (personTypeId) => ({
    type: actions.UPDATE_PERSON_TYPE,
    payload: personTypeId
})